module.exports = __webpack_public_path__ + "static/media/anzuum (2).e5eaf2b8.png";